export default __webpack_public_path__ + "static/media/n8n.c2fc1434.svg";